import { Users, UserPlus } from "lucide-react";

function SharedListMockup() {
  return (
    <div className="bg-warm-bg-card border border-warm-border rounded-2xl shadow-soft-lg p-6 space-y-5">
      {/* Board column — shared, tinted */}
      <div className="bg-warm-blue/5 border border-warm-border rounded-lg p-4 space-y-3">
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-sm font-medium text-warm-text-primary">
            <span className="text-lg leading-none">🎉</span>
            Team Offsite
            <Users size={13} className="text-warm-blue" />
          </span>
          <span className="bg-warm-blue/10 text-warm-blue px-2 py-0.5 rounded-full text-[10px] font-bold">
            2
          </span>
        </div>

        <div className="bg-warm-bg-base border border-warm-border-subtle rounded-lg px-3 py-2 space-y-1">
          <div className="flex items-center gap-2">
            <div className="w-3.5 h-3.5 rounded-full border-2 border-warm-blue shrink-0" />
            <span className="text-sm text-warm-text-primary">Book the venue</span>
          </div>
          <div className="text-[10px] text-warm-text-tertiary pl-5">
            Added by mia@example.com
          </div>
        </div>

        <div className="bg-warm-bg-base border border-warm-border-subtle rounded-lg px-3 py-2 flex items-center gap-2">
          <div className="w-3.5 h-3.5 rounded-full bg-warm-blue border-2 border-warm-blue shrink-0" />
          <span className="text-sm text-warm-text-tertiary line-through">Send invites</span>
        </div>
      </div>

      {/* Invite form */}
      <div className="flex items-center gap-2">
        <div className="flex-1 bg-warm-bg-elevated border border-warm-border rounded-soft px-3 py-2 text-xs text-warm-text-tertiary">
          name@example.com
        </div>
        <div className="flex-shrink-0 flex items-center gap-1.5 px-3 py-2 bg-warm-blue text-white rounded-soft text-xs font-medium">
          <UserPlus size={12} />
          Invite
        </div>
      </div>
    </div>
  );
}

export default SharedListMockup;
